/**
 * Format a price value using the currency's natural precision.
 *
 * The currency itself drives decimal places (HUF/JPY → 0, EUR/USD → 2).
 *
 * @example
 * formatCurrency(10.5, 'EUR', 'en')    // '€10.50'
 * formatCurrency(1599, 'HUF', 'hu')    // '1 599 Ft'
 * formatCurrency(10.555, 'EUR', 'de')  // '10,56 €'
 */
export const formatCurrency = (
  value: number | string | null | undefined,
  currencyCode = 'EUR',
  locale = 'en',
): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (Number.isNaN(numValue)) {
    return '';
  }

  const localeMap: Record<string, string> = {
    en: 'en-US',
    de: 'de-DE',
    hu: 'hu-HU',
  };

  const mappedLocale = localeMap[locale] || locale;

  return new Intl.NumberFormat(mappedLocale, {
    style: 'currency',
    currency: currencyCode,
  }).format(numValue);
};

export default formatCurrency;
